import React, { useEffect } from "react";
import { Outlet, useNavigate, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function HousingLoanLayout() {
  const navigate = useNavigate();

  const appId = useSelector((state) => state.token.appId);
  const productType = useSelector((state) => state.token.productType);
  const user = useSelector((state) => state.user);
  const hlEditUserDetail = useSelector((state) => state.temp.hlEditUserDetail);

  const pathName = window.location.pathname;

  // prettier-ignore
  useEffect(() => {
    if (user.userId) {
      // user data is fetched
      if (!appId && pathName !== `/user/housing-welcome-back` && user.hl_completed === 1) {
        // if welcome back process is not done for existing profile, redirect to welcome back
        navigate(`/user/housing-welcome-back`, { replace: true });
      } else if (pathName === `/user/affordable-housing-loan-detail` && user.hl_completed !== 0 && !hlEditUserDetail) {
        // if user detail is filled up and return to profile is not done, redirect to offers or lenders page
        navigate(`/user/housing-offers`, { replace: true });
      } else if (pathName !== `/user/affordable-housing-loan-detail` && user.hl_completed !== 1) {
        // if user detail is not filled up, redirect to user detail
        navigate(`/user/affordable-housing-loan-detail`, { replace: true });
      }
    }
  }, [user, pathName]);

  if (productType !== "Affordable Housing Loan") {
    // not the correct product type, redirect to products
    return <Navigate to={`/products`} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
}
